export default {
    NONE: 0,
    COMPLETED: 1,
    INITIALIZED: 2,
    RUNNING: 3,
    FAILED: 4
}